export function deriveEventNameFromPrompt(prompt: string) {
  const normalized = prompt.trim().replace(/\s+/g, ' ');
  if (!normalized) return 'Untitled Event';

  let name = normalized
    .replace(/^(create|launch|start|build|make|design|set\s*up|setup)\s+(me\s+)?/i, '')
    .replace(/^(a|an|the)\s+/i, '')
    .replace(/\b(viewer|live)\s+page\b/gi, 'event')
    .replace(/\bpage\b/gi, '')
    .split(/\b(with|using|styled like|based on|for)\b/i)[0]
    .replace(/[,:;.!?]+$/g, '')
    .trim();

  if (!name) return 'Untitled Event';

  name = name
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  if (!/\bevent\b/i.test(name)) {
    name = `${name} Event`;
  }

  return name.slice(0, 80);
}
